var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-caret-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.34156 13.3335H14.6582C14.823 13.3328 14.9839 13.2832 15.1206 13.1911C15.2572 13.0989 15.3635 12.9684 15.426 12.8158C15.4884 12.6633 15.5042 12.4957 15.4714 12.3342C15.4386 12.1727 15.3586 12.0245 15.2416 11.9085L10.5916 7.25846C10.5141 7.18035 10.4219 7.11836 10.3204 7.07605C10.2188 7.03374 10.1099 7.01196 9.99989 7.01196C9.88988 7.01196 9.78096 7.03374 9.67941 7.07605C9.57786 7.11836 9.48569 7.18035 9.40823 7.25846L4.75823 11.9085C4.64121 12.0245 4.56123 12.1727 4.52841 12.3342C4.49559 12.4957 4.5114 12.6633 4.57383 12.8158C4.63627 12.9684 4.74254 13.0989 4.87919 13.1911C5.01584 13.2832 5.17675 13.3328 5.34156 13.3335Z",
    fill: "#190044"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/CaretUP.8946676055cba049c547168382e57329.svg";
export { ForwardRef as ReactComponent };